import { Canvas, GaussianSplatting } from '@sloyd/3d';
import { Wrapper } from './ContentGuassian.style';

export type ContentGuassianProps = {};

const DEG2RAD = Math.PI / 180;

export function ContentGuassian(_props: ContentGuassianProps) {
  return (
    <Wrapper className='ContentGuassian-wrapper' data-testid='ContentGuassian-wrapper'>
      <Canvas
        cameraTarget={[0, -2, 0]}
        minDistance={2}
        cameraPosition={[0, -1, 2]}
        environment='dawn'
      >
        <GaussianSplatting
          rotation={[-32.3 * DEG2RAD, -18.5 * DEG2RAD, -6.4 * DEG2RAD]}
          src='https://huggingface.co/cakewalk/splat-data/resolve/main/nike.splat'
        />
      </Canvas>
    </Wrapper>
  );
}

export default ContentGuassian;
